/* global axios */
import { ref, computed, watch } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const AI_STATUS_URL = '/api/v1/nurture_fup/ai_status';

export function useAiStatus() {
  const currentChat = useMapGetter('getSelectedChat');

  const aiData = ref(null);
  const isLoading = ref(false);
  const error = ref(null);

  const aiStatus = computed(() => {
    const status = aiData.value?.ai_status;
    if (status === undefined || status === null) return null;
    return Boolean(status);
  });

  function getPhoneNumber() {
    const sender = currentChat.value?.meta?.sender;
    return sender?.phone_number || '';
  }

  function getInboxId() {
    return currentChat.value?.inbox_id;
  }

  async function fetchAiStatus() {
    const phone = getPhoneNumber();
    const inboxId = getInboxId();
    if (!phone || !inboxId) {
      aiData.value = null;
      return;
    }

    isLoading.value = true;
    error.value = null;

    try {
      const { data } = await axios.post(AI_STATUS_URL, {
        phone_number: phone,
        inbox_id: inboxId,
      });
      if (import.meta.env.DEV) {
        // eslint-disable-next-line no-console
        console.log('[AI_STATUS] Dados recebidos:', data);
      }
      aiData.value = data;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[AI_STATUS] Erro ao buscar status:', err);
      error.value = err.response?.data?.error || err.message;
      aiData.value = null;
    } finally {
      isLoading.value = false;
    }
  }

  watch(
    () => currentChat.value?.id,
    newId => {
      if (newId) {
        fetchAiStatus();
      } else {
        aiData.value = null;
      }
    },
    { immediate: true }
  );

  return {
    aiStatus,
    isLoading,
    error,
    fetchAiStatus,
  };
}
